import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
import { useNavigate } from 'react-router-dom';

export default function UserTickets() {
    const { t } = useTranslation();
    const [key, setKey] = useState(1);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'UserTickets',
            url: '/dashboard/UserTickets'
        },
    ];

    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    };

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="UserTickets"></HeaderOfPage>
            <div className="mt-6">
                <ListofUserTickets key={key} reloaditem={reloadgame}></ListofUserTickets>
            </div>
        </div>
    );
}

function ListofUserTickets({ reloaditem }: { reloaditem: () => void }) {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [statusFilter, setStatusFilter] = useState<string>('all');
    const navigate = useNavigate();

    const load = async () => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams({
                page: currentPage.toString(),
            });
            
            if (statusFilter !== 'all') {
                const statusMap: { [key: string]: string } = {
                    'reviewing': '1',
                    'answered': '2',
                    'closed': '3'
                };
                queryParams.append('status', statusMap[statusFilter] || statusFilter);
            }

            const response = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/tickets?${queryParams.toString()}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(response.data.message);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading tickets'),
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [currentPage, statusFilter]);

    const getStatusText = (status: number) => {
        if (status === 1) return t('Reviewing');
        if (status === 2) return t('Answered');
        if (status === 3) return t('Closed');
        return t('Reviewing');
    };

    const getStatusColor = (status: number) => {
        if (status === 1) return 'bg-gray-200 text-gray-800';
        if (status === 2) return 'bg-green-100 text-green-600';
        if (status === 3) return 'bg-gray-300 text-gray-400';
        return 'bg-gray-200 text-gray-800';
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            {/* Filter Section */}
            <div className="mb-6">
                <label className="text-sm font-medium text-gray-700">{t('Filter')}:</label>
                <select
                    value={statusFilter}
                    onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(1);
                    }}
                    className="mt-2 block w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                    <option value="all">{t('All Tickets')}</option>
                    <option value="reviewing">{t('Reviewing')}</option>
                    <option value="answered">{t('Answered')}</option>
                    <option value="closed">{t('Closed')}</option>
                </select>
            </div>

            {loading ? (
                <div className="text-center py-8">
                    <p className="text-gray-500">{t('Loading...')}</p>
                </div>
            ) : list && list.docs && list.docs.length > 0 ? (
                <>
                    <div className="space-y-4">
                        {list.docs.map((item: any) => {
                            // Handle status - can be number or string
                            const statusNum = typeof item.status === 'string' 
                                ? (item.status === 'reviewing' ? 1 : item.status === 'answered' ? 2 : item.status === 'closed' ? 3 : 1)
                                : item.status;
                            
                            return (
                            <div
                                key={item.id || item._id}
                                className="border border-gray-200 rounded-xl p-5 hover:shadow-md transition-shadow cursor-pointer"
                                onClick={() => navigate(`/dashboard/Tickets/${item.id || item._id}`)}
                            >
                                {/* Header */}
                                <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                                    <h3 className="font-bold text-xl text-gray-800">
                                        {item.title || item.data?.subject || 'No Subject'}
                                    </h3>
                                    <div className="flex items-center gap-4">
                                        <div
                                            className={`px-4 py-1 rounded-full text-sm font-medium ${getStatusColor(statusNum)}`}
                                        >
                                            {getStatusText(statusNum)}
                                        </div>
                                        <div className="text-sm text-gray-600">
                                            {new Date(item.date || item.createdAt).toLocaleDateString()}
                                        </div>
                                    </div>
                                </div>

                                {/* User Info */}
                                <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                                        <div>
                                            <span className="font-medium text-gray-700">{t('User Email')}:</span>{' '}
                                            <span className="text-gray-600">{item.user?.email || item.email || 'N/A'}</span>
                                        </div>
                                        <div>
                                            <span className="font-medium text-gray-700">{t('User Phone')}:</span>{' '}
                                            <span className="text-gray-600">{item.user?.phone || item.phone || 'N/A'}</span>
                                        </div>
                                        <div>
                                            <span className="font-medium text-gray-700">{t('Name')}:</span>{' '}
                                            <span className="text-gray-600">
                                                {(item.user?.name || item.name || 'N/A')} {(item.user?.lastname || item.lastname || '')}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Message */}
                                <div className="mb-4">
                                    <p className="text-gray-700 text-justify">
                                        {item.description || item.data?.message || 'No message'}
                                    </p>
                                </div>

                        
                            </div>
                            );
                        })}
                    </div>

                    {/* Pagination */}
                    {list.totalPages > 1 && (
                        <div className="mt-6 flex items-center justify-between">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                disabled={currentPage === 1}
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300"
                            >
                                {t('Previous')}
                            </button>
                            <span className="text-gray-600">
                                {t('Page')} {currentPage} {t('of')} {list.totalPages}
                            </span>
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(list.totalPages, prev + 1))}
                                disabled={currentPage === list.totalPages}
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300"
                            >
                                {t('Next')}
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <div className="text-center py-8">
                    <p className="text-gray-500">{t('No tickets found')}</p>
                </div>
            )}
        </div>
    );
}

